import '../index.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { translate } from '@utils';
import { Paths } from '@constants/paths';
import { useSelector } from 'react-redux';
import { hasUnsentAnswersSelector } from '@selectors/user';
import { Indicator } from '@images/icons';
import { hasPermissionPage } from '@hooks/hasPermissionPage';
import { PagePermission, PermissionActions } from '@enums';

export const NavigationComponent = () => {
  const { pathname } = useLocation();
  const hasUnsentAnswers = useSelector(hasUnsentAnswersSelector);
  const hasAnswers = hasPermissionPage([PagePermission.Answers], [PermissionActions.View]);
  const hasLetters = hasPermissionPage([PagePermission.Letters], [PermissionActions.View]);
  const hasQuestionnaires = hasPermissionPage(
    [PagePermission.Questionnaires],
    [PermissionActions.View]
  );
  return (
    <div className="navigation" data-testid="navigation">
      {hasLetters && (
        <NavLink
          className={({ isActive }) => `navigation-link${isActive ? ' active' : ''}`}
          to={pathname.includes(Paths.LETTERS) ? `${pathname}` : Paths.LETTERS}
        >
          {translate('letters')}
        </NavLink>
      )}
      {hasAnswers && (
        <NavLink
          className={({ isActive }) => `navigation-link${isActive ? ' active' : ''}`}
          to={Paths.ANSWERS}
        >
          {translate('answers')}
          {hasUnsentAnswers && <Indicator className="answers-indicator" />}
        </NavLink>
      )}
      {hasQuestionnaires && (
        <NavLink
          className={({ isActive }) => `navigation-link${isActive ? ' active' : ''}`}
          to={PagePermission.Questionnaires}
          data-testid="questionnaires-link"
        >
          {translate('questionnaires')}
        </NavLink>
      )}
    </div>
  );
};
